/* unplugin-vue-components disabled */import { render } from "./UserCell.vue?vue&type=template&id=1312ab46&scoped=true&ts=true"
import script from "./UserCell.vue?vue&type=script&lang=ts"
export * from "./UserCell.vue?vue&type=script&lang=ts"

import "./UserCell.vue?vue&type=style&index=0&id=1312ab46&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1312ab46"]])

export default __exports__